import MobilePaymentsTab from './MobilePaymentsTab';

export default MobilePaymentsTab;